import React from "react";

const Gloom = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-2.65 -1.2 280.6 237.3"
      {...rest}
    >
      <g>
        <path
          fill="#0d131a"
          d="M171.3 32.9 Q172.6 47.9 162.7 59.55 152.8 71.15 137.65 72.45 122.5 73.75 110.8 64.05 99.0 54.25 97.7 39.25 96.4 24.2 106.2 12.8 115.95 1.4 131.15 0.1 146.35 -1.2 158.15 8.35 170.0 17.95 171.3 32.9"
        />
        <path
          fill="#b76870"
          d="M156.4 9.9 Q167.2 18.95 168.4 32.9 169.6 46.9 160.5 57.65 151.4 68.4 137.35 69.6 123.35 70.85 112.5 61.8 101.7 52.75 100.5 38.8 99.25 24.85 108.35 14.05 117.45 3.3 131.5 2.05 145.55 0.85 156.4 9.9"
        />
        <path
          fill="#904f57"
          d="M142.55 42.0 Q158.45 29.55 159.65 13.05 167.35 21.5 168.4 32.9 169.6 46.9 160.5 57.65 151.4 68.4 137.35 69.6 128.65 70.35 120.7 66.9 113.05 63.5 107.75 56.95 L110.4 56.5 Q128.9 52.65 142.55 42.0"
        />
        <path
          fill="#f5e7e6"
          d="M124.0 14.1 Q123.4 13.75 124.1 12.35 124.65 11.2 125.75 10.5 126.75 9.9 127.65 10.0 128.65 10.1 128.85 11.1 129.1 12.15 127.9 13.55 127.6 13.95 126.2 14.25 L124.0 14.1"
        />
        <path
          fill="#f5e7e6"
          d="M141.35 16.65 Q140.25 15.15 140.4 13.55 140.5 11.9 141.85 10.4 143.3 8.8 145.15 9.4 150.25 11.1 151.85 14.7 153.3 17.9 151.35 18.75 148.4 20.05 145.45 19.3 142.75 18.6 141.35 16.65"
        />
        <path
          fill="#0d131a"
          d="M71.55 164.2 Q75.1 162.75 77.35 163.75 78.45 164.2 79.95 165.95 81.45 167.7 81.8 170.55 82.15 173.5 81.0 175.55 L80.2 176.95 Q77.35 182.3 73.75 185.65 67.9 191.15 59.1 193.1 52.65 194.55 47.85 191.8 43.7 189.45 42.65 185.25 L42.45 184.2 Q42.15 179.95 46.4 178.7 55.3 176.15 65.75 168.25 L68.95 165.8 Q70.6 164.6 71.55 164.2"
        />
        <path
          fill="#5892bf"
          d="M71.3 167.05 Q76.05 165.2 78.05 167.55 79.05 168.7 79.15 170.45 79.25 172.25 78.4 173.65 L77.6 175.1 Q74.3 181.2 72.3 183.4 67.6 188.5 59.6 190.3 53.95 191.55 49.85 189.6 46.4 187.95 45.7 185.1 45.25 183.35 45.45 182.55 45.65 181.45 47.1 181.05 52.4 179.55 57.95 176.2 L66.2 170.5 Q69.95 167.65 71.3 167.05"
        />
        <path
          fill="#46799e"
          d="M78.05 167.55 Q79.05 168.7 79.15 170.45 79.25 172.25 78.4 173.65 L77.6 175.1 75.1 179.65 Q73.35 182.55 71.1 184.6 66.55 177.6 60.15 174.8 L66.2 170.5 Q69.95 167.65 71.3 167.05 76.05 165.2 78.05 167.55"
        />
        <path
          fill="#0d131a"
          d="M185.35 162.45 Q186.35 161.4 187.7 161.3 189.7 161.15 192.0 163.0 196.65 166.75 200.15 168.65 208.05 172.8 219.5 174.8 222.1 175.25 223.3 177.05 224.5 178.8 224.15 181.4 223.65 185.3 219.75 187.85 215.45 190.65 208.85 190.35 199.9 189.9 192.9 184.9 188.85 182.1 184.75 176.9 L184.4 175.75 Q182.5 173.55 182.85 169.1 183.15 164.7 185.35 162.45"
        />
        <path
          fill="#5892bf"
          d="M190.45 164.9 Q200.25 172.8 218.3 176.5 219.95 176.85 220.8 178.2 221.6 179.5 221.4 181.15 221.1 183.8 218.1 185.7 214.45 188.0 208.5 187.7 200.25 187.3 193.7 182.65 189.85 179.95 185.9 174.95 L185.35 173.4 Q184.15 171.95 184.85 168.8 185.55 165.8 187.1 164.2 188.05 163.05 190.45 164.9"
        />
        <path
          fill="#46799e"
          d="M202.4 171.75 Q193.95 173.45 188.9 178.45 L185.9 174.95 185.35 173.4 Q184.15 171.95 184.85 168.8 185.55 165.8 187.1 164.2 188.05 163.05 190.45 164.9 195.15 168.7 202.4 171.75"
        />
        <path
          fill="#0d131a"
          d="M99.15 187.45 Q100.9 186.65 103.8 186.95 106.85 187.25 108.65 188.6 110.65 190.05 110.35 192.2 108.85 205.2 110.6 207.15 115.5 212.75 111.55 218.5 108.9 222.4 98.15 227.0 85.75 232.35 70.5 234.75 66.45 235.4 62.35 233.85 58.3 232.35 56.0 229.5 53.55 226.45 54.25 223.05 55.0 219.25 59.75 215.95 64.1 212.9 79.9 209.1 L95.7 205.55 Q97.05 204.95 97.4 201.15 L97.45 194.35 Q97.35 190.65 97.5 189.4 97.65 188.15 99.15 187.45"
        />
        <path
          fill="#5892bf"
          d="M106.45 190.15 Q108.05 190.9 107.9 191.9 106.3 205.15 108.55 208.5 110.1 210.9 110.35 212.35 110.8 215.05 108.65 217.95 106.7 220.6 95.55 225.0 82.65 230.1 70.3 231.6 61.35 232.7 58.4 227.45 57.1 225.2 57.8 222.65 58.55 220.0 61.2 217.95 65.2 214.95 80.85 211.3 L96.75 207.75 Q99.05 206.65 99.7 202.5 100.05 200.05 99.9 194.3 L99.95 189.85 Q100.5 189.35 102.5 189.35 104.75 189.35 106.45 190.15"
        />
        <path
          fill="#46799e"
          d="M99.9 194.3 L99.95 189.85 Q100.5 189.35 102.5 189.35 104.75 189.35 106.45 190.15 108.05 190.9 107.9 191.9 106.3 205.15 108.55 208.5 L109.75 210.55 Q110.35 211.85 110.4 213.1 104.75 208.1 98.45 206.15 99.6 204.4 99.85 200.9 100.05 198.65 99.9 194.3"
        />
        <path
          fill="#0d131a"
          d="M164.35 190.15 Q165.9 190.75 166.05 192.0 166.5 195.05 169.95 200.25 173.55 205.6 176.1 206.65 L189.8 209.3 Q204.15 212.25 211.8 216.1 215.15 217.8 216.85 221.15 218.5 224.55 217.6 227.85 215.45 236.1 201.95 235.05 192.45 234.3 180.2 230.25 166.5 225.8 163.2 221.25 161.6 219.05 161.0 214.2 L160.7 209.85 Q160.65 208.4 159.5 206.35 L157.05 202.5 154.65 198.85 Q153.55 196.9 153.3 195.35 153.0 193.25 154.85 191.7 156.6 190.3 159.65 189.85 L164.35 190.15"
        />
        <path
          fill="#5892bf"
          d="M161.05 192.2 L163.65 192.55 Q164.25 196.3 168.1 201.9 172.05 207.65 175.15 208.95 L188.35 211.2 Q202.1 213.85 209.9 217.75 211.85 218.7 213.35 221.05 214.95 223.6 214.9 225.95 214.75 232.3 203.5 232.0 191.2 231.65 178.3 226.75 167.8 222.8 165.35 219.85 163.4 217.55 163.1 213.45 L163.15 209.75 Q163.1 207.85 161.8 205.4 L159.05 201.1 Q156.05 196.7 155.75 194.95 155.6 194.0 157.1 193.15 158.75 192.3 161.05 192.2"
        />
        <path
          fill="#46799e"
          d="M155.75 194.95 Q155.6 194.0 157.1 193.15 158.75 192.3 161.05 192.2 L163.65 192.55 Q164.05 194.9 166.1 198.55 168.05 202.15 170.5 205.0 166.2 206.85 163.05 210.75 L163.15 209.75 Q163.1 207.85 161.8 205.4 L159.05 201.1 Q156.05 196.7 155.75 194.95"
        />
        <path
          fill="#0d131a"
          d="M193.3 135.35 Q198.5 169.35 181.6 186.8 166.5 202.3 134.85 203.85 100.95 205.5 82.45 191.8 62.1 176.75 65.7 146.3 69.05 117.55 83.1 99.0 98.8 78.2 124.15 76.0 150.25 73.75 170.5 92.4 189.45 109.9 193.3 135.35"
        />
        <path
          fill="#5892bf"
          d="M178.05 185.2 Q162.55 200.3 134.15 201.3 99.5 202.55 82.2 187.35 65.3 172.5 68.35 145.15 71.35 118.25 85.0 100.55 100.1 80.95 124.05 78.9 148.8 76.75 167.5 92.95 185.65 108.7 190.3 134.6 196.3 167.45 178.05 185.2"
        />
        <path
          fill="#46799e"
          d="M178.5 121.1 Q167.65 117.5 160.5 117.5 159.15 117.5 156.95 119.1 L152.1 122.75 Q144.05 128.1 132.2 128.55 122.25 128.9 113.65 125.3 L104.35 120.2 Q99.95 117.7 87.35 123.85 75.9 129.45 69.85 135.45 74.6 111.95 87.8 97.15 102.35 80.75 124.05 78.9 146.25 76.95 163.85 90.05 180.8 102.65 187.85 124.6 183.9 122.9 178.5 121.1"
        />
        <path
          fill="#0d131a"
          d="M162.25 156.3 Q164.85 157.7 165.45 160.35 166.0 162.9 164.45 165.2 162.6 167.9 158.1 169.55 148.25 173.2 127.5 172.4 105.05 171.55 98.0 165.35 93.55 161.4 95.65 156.95 96.8 154.55 99.6 153.5 102.25 152.55 105.55 153.05 L110.85 154.0 Q122.45 156.45 135.0 156.55 L156.45 155.35 Q159.75 155.0 162.25 156.3"
        />
        <path
          fill="#b6aed1"
          d="M110.4 155.75 Q122.15 157.85 127.75 158.05 L156.65 157.15 Q159.15 156.95 161.0 158.15 162.7 159.3 163.05 160.95 163.5 162.95 161.95 164.75 160.4 166.55 157.25 167.7 148.0 171.15 127.85 170.45 106.15 169.7 99.6 163.95 96.25 160.9 97.55 158.15 98.35 156.4 100.6 155.45 102.8 154.5 105.15 154.85 L110.4 155.75"
        />
        <path
          fill="#0d131a"
          d="M77.0 140.65 Q74.85 140.2 75.2 139.4 75.5 138.65 77.6 138.7 87.4 138.85 96.35 134.9 104.7 131.2 111.05 124.55 112.8 122.7 113.6 123.5 114.35 124.3 112.95 126.15 108.15 132.5 98.25 137.2 86.65 142.75 77.0 140.65"
        />
        <path
          fill="#0d131a"
          d="M177.85 142.7 Q167.45 144.95 156.95 140.55 146.8 136.25 141.9 128.2 140.7 126.2 141.45 125.45 142.15 124.7 143.8 126.65 150.5 134.55 158.95 137.9 166.6 140.9 177.25 140.75 179.35 140.7 179.65 141.45 180.0 142.25 177.85 142.7"
        />
        <path
          fill="#0d131a"
          d="M103.05 160.85 Q101.5 160.25 101.7 159.55 L103.85 159.5 Q111.3 162.15 125.95 162.95 142.1 163.85 154.4 161.55 L157.5 161.7 Q157.05 162.5 155.0 163.0 145.35 165.5 131.15 165.4 114.05 165.35 103.05 160.85"
        />
        <path
          fill="#0d131a"
          d="M172.3 97.0 Q170.65 97.05 169.95 95.9 L169.25 94.0 Q167.75 90.8 173.45 82.65 176.85 77.75 182.1 72.1 L182.25 71.95 182.2 74.75 Q189.95 70.85 201.3 72.4 213.75 74.1 223.45 81.85 234.95 91.05 239.6 103.75 244.25 116.45 240.85 129.65 240.5 131.1 239.8 130.85 239.1 130.6 238.55 129.2 231.85 115.2 214.05 106.0 195.0 96.15 172.3 97.0"
        />
        <path
          fill="#ef8200"
          d="M201.55 73.85 Q212.85 76.95 222.35 84.55 228.8 89.7 233.05 96.05 238.9 104.8 239.75 114.75 240.2 120.1 239.2 125.85 231.0 111.8 214.0 102.7 195.2 92.7 173.35 93.5 171.8 93.65 171.5 93.0 L171.4 92.5 Q171.2 90.4 175.1 84.75 178.7 79.45 183.75 74.0 190.3 70.8 201.55 73.85"
        />
        <path
          fill="#cf7100"
          d="M200.25 97.0 Q187.2 92.95 173.35 93.5 171.8 93.65 171.5 93.0 L171.4 92.5 Q171.2 90.4 175.1 84.75 178.7 79.45 183.75 74.0 190.3 70.8 201.55 73.85 212.85 76.95 222.35 84.55 233.25 93.25 237.55 104.8 229.85 105.4 222.05 107.65 212.15 100.65 200.25 97.0"
        />
        <path
          fill="#0d131a"
          d="M246.75 31.05 Q244.2 28.35 244.4 27.95 244.6 27.4 248.35 29.3 263.5 36.9 270.25 52.1 277.95 69.55 268.1 86.15 262.7 95.3 252.95 101.8 243.25 108.35 231.25 111.0 204.25 117.0 179.95 102.55 L179.9 102.5 179.8 102.45 Q177.65 100.75 177.55 97.85 177.45 92.25 185.75 82.7 189.95 77.85 194.6 73.75 L196.1 72.4 196.6 74.35 Q197.1 76.5 199.9 78.1 202.7 79.65 207.25 80.35 218.65 82.05 231.45 78.05 246.1 73.5 251.9 63.9 256.05 57.05 254.35 47.05 252.65 37.4 246.75 31.05"
        />
        <path
          fill="#ef8200"
          d="M265.7 47.7 Q270.45 55.15 271.1 63.25 272.1 74.1 266.05 84.3 260.75 93.2 251.55 99.6 242.3 106.0 230.9 108.65 205.2 114.6 181.3 100.5 180.15 99.5 180.0 98.05 L180.0 97.75 Q179.9 93.85 185.5 86.8 189.45 81.8 194.95 76.7 197.7 81.4 206.9 82.75 218.85 84.6 232.35 80.3 247.8 75.45 254.0 65.2 258.0 58.6 257.3 50.55 256.55 42.2 250.75 32.65 260.5 39.5 265.7 47.7"
        />
        <path
          fill="#cf7100"
          d="M180.0 98.05 L180.0 97.75 Q179.9 93.85 185.5 86.8 189.45 81.8 194.95 76.7 197.7 81.4 206.9 82.75 215.05 84.05 224.85 82.15 219.4 94.35 217.95 110.25 198.65 110.75 181.3 100.5 180.15 99.5 180.0 98.05"
        />
        <path
          fill="#0d131a"
          d="M85.65 78.25 L86.75 78.3 Q119.35 85.65 119.35 93.6 119.35 98.65 105.8 101.8 80.8 107.7 70.95 130.5 67.2 139.1 66.2 149.0 65.35 157.2 66.45 163.8 66.85 165.65 66.65 165.9 66.35 166.35 64.75 164.85 50.35 152.8 46.4 138.9 43.4 128.25 46.6 116.7 50.7 101.95 63.0 90.55 74.35 79.95 85.65 78.25"
        />
        <path
          fill="#ef8200"
          d="M115.0 95.9 Q112.1 97.8 105.25 99.4 81.1 105.05 70.3 126.9 62.25 143.2 63.75 160.7 L63.85 161.35 Q49.15 147.95 47.75 131.75 47.1 124.55 49.2 117.0 53.05 103.1 64.6 91.95 75.45 81.5 85.8 79.85 97.0 82.45 106.0 86.1 116.65 90.4 116.9 93.45 L116.9 93.6 Q116.9 94.7 115.0 95.9"
        />
        <path
          fill="#cf7100"
          d="M116.9 93.45 L116.9 93.6 Q116.9 94.7 115.0 95.9 112.1 97.8 105.25 99.4 94.05 102.05 85.55 108.35 80.85 103.65 74.5 100.15 68.4 96.8 61.7 95.0 67.25 88.85 73.75 84.8 80.15 80.75 85.8 79.85 97.0 82.45 106.0 86.1 116.65 90.4 116.9 93.45"
        />
        <path
          fill="#0d131a"
          d="M165.05 87.9 Q169.95 83.45 176.5 78.9 L176.7 78.75 177.45 80.75 Q188.25 78.8 198.35 84.0 208.9 89.5 215.85 101.55 224.25 116.1 223.35 134.1 222.45 152.35 212.4 164.2 210.4 166.3 210.45 163.4 210.7 156.65 208.5 147.95 205.95 137.65 200.85 128.9 187.35 105.65 162.0 102.2 L158.8 101.5 Q157.6 100.9 157.3 99.7 156.4 95.8 165.05 87.9"
        />
        <path
          fill="#ef8200"
          d="M197.15 85.45 Q206.95 91.35 213.65 102.95 220.25 114.5 221.4 127.5 222.95 145.75 212.65 159.85 L212.5 157.7 Q210.95 139.2 200.85 124.1 187.0 103.35 161.85 99.9 L160.5 99.8 Q159.85 99.7 159.7 99.15 L159.65 98.9 Q159.45 96.55 165.6 90.75 170.8 85.9 177.65 81.1 187.35 79.5 197.15 85.45"
        />
        <path
          fill="#cf7100"
          d="M177.65 81.1 Q185.95 79.7 194.45 83.9 202.85 88.1 209.5 96.75 203.75 97.7 196.9 101.15 193.1 103.1 184.9 108.25 174.8 101.65 161.85 99.9 L160.5 99.8 Q159.85 99.7 159.7 99.15 L159.65 98.9 Q159.45 96.55 165.6 90.75 170.8 85.9 177.65 81.1"
        />
        <path
          fill="#0d131a"
          d="M38.2 143.45 Q37.35 151.25 33.75 155.25 30.25 159.15 24.35 159.2 15.95 159.3 10.25 150.1 3.7 139.6 3.0 120.0 L4.5 120.75 Q5.4 130.4 10.4 138.25 15.25 145.85 21.4 147.8 30.5 150.75 36.5 141.95 37.6 140.45 37.95 140.9 38.25 141.25 38.2 143.45"
        />
        <path
          fill="#cf7100"
          d="M13.65 144.95 Q17.35 148.75 21.35 150.05 28.85 152.45 35.9 146.05 35.05 151.1 31.95 154.15 28.9 157.15 24.75 157.2 19.0 157.25 14.5 152.5 9.15 146.8 7.45 135.9 10.1 141.3 13.65 144.95"
        />
        <path
          fill="#0d131a"
          d="M83.75 88.4 L84.9 91.6 81.25 91.3 Q69.85 84.7 52.6 87.65 35.7 90.55 23.8 100.55 13.35 109.35 10.45 122.7 7.6 136.15 13.1 151.1 L15.1 153.9 14.55 154.8 Q10.6 152.45 7.15 145.8 3.7 139.2 1.8 130.3 -2.65 109.55 3.2 92.05 8.35 76.8 19.5 67.9 35.4 55.15 60.95 58.05 67.85 59.3 75.95 72.75 81.1 81.25 83.75 88.4"
        />
        <path
          fill="#ef8200"
          d="M21.2 69.3 Q36.25 57.05 60.6 59.85 65.35 60.7 71.65 71.2 76.25 78.85 80.25 88.95 67.7 83.25 50.85 86.05 33.9 88.85 22.25 98.65 14.1 105.5 10.4 114.65 6.7 123.8 7.65 134.55 8.1 140.2 9.9 146.1 7.0 142.5 5.05 136.4 3.1 130.3 2.45 122.8 1.05 106.8 5.85 92.4 10.75 77.8 21.2 69.3"
        />
        <path
          fill="#cf7100"
          d="M80.25 88.95 Q70.4 84.45 57.0 85.35 57.1 78.5 54.75 71.65 52.4 64.85 48.0 59.45 L60.6 59.85 Q65.35 60.7 71.65 71.2 76.25 78.85 80.25 88.95"
        />
        <path
          fill="#0d131a"
          d="M91.1 21.05 Q107.25 19.65 120.05 31.15 132.65 42.45 134.1 59.0 135.45 75.0 124.9 85.85 114.7 96.3 97.95 97.7 81.4 99.15 68.95 89.2 56.35 79.15 54.95 62.9 53.55 46.65 64.15 34.5 74.65 22.5 91.1 21.05"
        />
        <path
          fill="#b76870"
          d="M117.15 31.5 Q128.7 41.2 129.95 56.15 131.25 71.1 121.55 82.6 111.9 94.1 96.95 95.4 82.05 96.7 70.5 87.0 59.0 77.35 57.7 62.4 56.45 47.45 66.1 35.95 75.8 24.45 90.7 23.15 105.65 21.85 117.15 31.5"
        />
        <path
          fill="#904f57"
          d="M114.4 89.1 Q106.55 94.55 96.95 95.4 88.6 96.1 80.8 93.1 73.25 90.15 67.65 84.3 82.2 90.35 98.5 88.1 115.2 85.7 126.25 75.5 122.05 83.8 114.4 89.1"
        />
        <path
          fill="#0d131a"
          d="M169.25 23.7 Q185.0 22.35 197.1 32.45 209.2 42.55 210.6 58.25 211.95 73.95 201.75 85.8 191.6 97.55 175.8 98.9 160.0 100.3 147.95 90.45 135.85 80.5 134.5 64.85 133.1 49.1 143.3 37.1 153.5 25.05 169.25 23.7"
        />
        <path
          fill="#b76870"
          d="M195.05 34.2 Q206.35 43.7 207.6 58.3 208.9 72.95 199.4 84.25 189.9 95.5 175.25 96.75 160.6 98.05 149.35 88.55 138.1 79.05 136.8 64.4 135.55 49.75 145.0 38.5 154.5 27.25 169.15 25.95 183.8 24.7 195.05 34.2"
        />
        <path
          fill="#904f57"
          d="M197.75 86.0 Q188.5 95.65 175.25 96.75 165.65 97.6 157.0 93.5 148.65 89.5 143.2 81.9 158.5 85.25 173.4 80.35 187.5 75.65 200.15 63.9 201.3 62.75 203.4 62.65 205.4 62.5 207.65 63.35 206.95 76.45 197.75 86.0"
        />
        <path
          fill="#0d131a"
          d="M123.75 27.95 Q128.45 26.35 133.45 26.45 138.4 26.6 142.75 28.45 147.15 30.3 150.2 33.5 155.05 38.65 154.9 45.15 154.7 52.65 148.1 57.8 141.55 62.95 132.5 62.7 127.55 62.55 123.15 60.7 118.8 58.85 115.75 55.65 110.2 49.85 110.4 44.0 110.55 37.5 115.7 32.6 118.85 29.6 123.75 27.95"
        />
        <path
          fill="#ef8200"
          d="M151.9 44.25 Q151.75 50.7 145.9 55.15 140.1 59.6 132.05 59.35 127.6 59.25 123.65 57.6 119.75 55.95 117.0 53.1 112.85 48.65 113.0 43.2 113.15 37.65 117.55 33.5 120.4 30.8 124.4 29.35 128.45 27.95 132.9 28.05 137.35 28.2 141.25 29.85 145.2 31.5 147.9 34.35 152.05 38.75 151.9 44.25"
        />
        <path
          fill="#cf7100"
          d="M147.9 34.35 Q152.05 38.75 151.9 44.25 151.75 50.7 145.9 55.15 140.1 59.6 132.05 59.35 126.55 59.2 122.0 56.8 133.25 57.35 140.75 51.15 149.15 44.2 146.15 32.75 L147.9 34.35"
        />
        <path
          fill="#0d131a"
          d="M126.75 37.85 Q143.45 36.45 156.15 47.3 168.8 58.1 170.25 74.85 171.7 91.55 161.0 104.25 150.25 116.95 133.5 118.35 116.65 119.8 103.55 109.2 90.3 98.5 88.9 81.85 87.45 65.2 98.75 52.2 109.9 39.3 126.75 37.85"
        />
        <path
          fill="#b76870"
          d="M154.1 48.8 Q166.2 59.0 167.55 74.7 168.95 90.45 158.75 102.55 148.55 114.65 132.85 116.0 117.1 117.4 105.0 107.2 92.9 97.0 91.55 81.3 90.15 65.55 100.35 53.45 110.55 41.35 126.25 40.0 142.0 38.6 154.1 48.8"
        />
        <path
          fill="#904f57"
          d="M165.0 63.85 Q167.1 69.15 167.55 74.7 168.95 90.45 158.75 102.55 148.55 114.65 132.85 116.0 124.45 116.75 116.6 113.9 109.05 111.15 103.15 105.55 121.85 109.25 135.65 100.85 148.75 92.85 156.1 74.95 159.5 66.6 162.1 64.45 163.1 63.6 165.0 63.85"
        />
        <path
          fill="#f5e7e6"
          d="M139.65 56.85 Q139.85 54.65 141.4 53.3 143.2 51.65 146.4 51.75 149.15 51.8 151.2 54.65 152.9 57.0 153.65 60.35 154.5 64.2 153.1 65.9 151.9 67.45 149.5 67.45 147.2 67.45 144.8 66.1 139.05 62.8 139.65 56.85"
        />
        <path
          fill="#f5e7e6"
          d="M99.9 38.25 Q100.2 39.75 98.5 41.9 97.0 43.75 95.2 44.7 93.0 45.8 91.25 45.0 89.25 44.05 88.6 42.45 88.1 41.1 88.65 39.7 90.15 35.65 94.7 35.25 99.15 34.8 99.9 38.25"
        />
        <path
          fill="#f5e7e6"
          d="M112.0 75.3 Q111.6 74.65 111.55 73.55 111.5 72.25 111.95 71.3 112.65 70.0 114.1 69.85 116.25 69.65 117.5 71.5 118.1 72.45 118.3 73.4 119.8 77.7 117.15 78.55 114.55 79.45 112.0 75.3"
        />
        <path
          fill="#f5e7e6"
          d="M72.2 48.85 Q72.7 49.35 72.95 50.8 73.45 54.75 71.25 55.9 69.05 57.1 66.9 53.65 66.5 53.0 66.45 51.9 66.4 50.6 66.85 49.65 67.55 48.35 69.0 48.2 71.3 47.95 72.2 48.85"
        />
        <path
          fill="#f5e7e6"
          d="M135.8 86.8 Q134.8 86.15 134.8 85.1 134.8 84.05 135.9 83.3 136.4 82.9 136.9 83.05 L137.95 83.8 138.5 84.65 Q139.2 86.1 138.95 86.55 L137.6 87.1 Q136.55 87.3 135.8 86.8"
        />
        <path
          fill="#f5e7e6"
          d="M163.45 47.8 Q162.55 47.2 162.45 46.1 162.45 45.1 163.55 44.3 164.1 43.9 164.55 44.05 165.55 44.35 166.2 45.65 166.9 47.25 166.6 47.55 166.15 47.95 165.25 48.1 164.2 48.3 163.45 47.8"
        />
        <path
          fill="#f5e7e6"
          d="M85.4 70.6 Q84.5 70.0 84.4 68.9 84.4 67.85 85.5 67.1 86.05 66.7 86.5 66.85 87.45 67.1 88.15 68.45 88.8 69.9 88.55 70.35 L87.2 70.9 Q86.15 71.1 85.4 70.6"
        />
        <path
          fill="#f5e7e6"
          d="M119.25 52.4 Q118.55 51.9 118.55 51.2 118.55 50.5 119.3 49.95 L120.0 49.75 Q120.65 49.9 121.15 50.9 121.65 52.0 121.45 52.2 L120.5 52.6 119.25 52.4"
        />
        <path
          fill="#f5e7e6"
          d="M184.3 64.2 Q183.65 63.8 183.65 63.15 183.65 62.5 184.35 61.95 L185.0 61.8 185.65 62.3 186.0 62.85 Q186.5 63.85 186.3 64.05 L185.45 64.4 184.3 64.2"
        />
        <path
          fill="#f5e7e6"
          d="M117.2 22.1 Q116.75 21.7 116.65 21.15 116.65 20.6 117.25 20.2 117.55 20.0 117.8 20.05 118.25 20.2 118.7 20.9 119.1 21.75 118.9 21.95 L118.2 22.25 117.2 22.1"
        />
        <path
          fill="#0d131a"
          d="M145.65 170.7 Q145.8 169.95 144.5 168.95 L142.1 167.5 Q139.2 165.75 139.35 164.8 139.55 163.45 142.5 163.1 L148.55 162.9 154.8 162.25 156.25 161.55 Q156.9 161.15 157.35 161.3 158.7 161.8 158.65 164.15 158.6 166.3 157.85 167.0 157.6 167.8 158.0 170.25 L158.2 172.0 Q158.3 173.35 157.95 174.1 L157.1 175.15 Q156.45 175.55 156.15 176.45 156.0 176.9 156.3 179.2 156.7 181.75 156.55 183.05 156.25 185.2 154.55 185.7 152.1 186.4 151.25 181.0 L150.6 178.4 Q150.2 179.25 149.6 179.65 149.0 180.05 148.45 179.9 146.35 179.3 145.65 176.7 145.0 174.3 145.65 170.7"
        />
        <path
          fill="#ffffff"
          d="M148.55 163.7 Q151.75 163.65 155.05 162.5 L155.85 162.2 156.9 162.0 157.35 162.85 157.5 164.25 Q157.45 165.0 156.65 166.65 156.4 167.3 156.5 168.6 L157.0 172.1 157.0 173.6 156.55 174.25 155.75 174.85 Q155.2 175.35 154.95 176.05 154.75 176.6 154.85 177.7 L155.35 181.3 Q155.6 183.85 154.25 184.25 153.55 184.05 153.1 182.6 L152.55 180.3 151.6 177.7 Q151.2 176.9 150.6 176.85 149.95 176.85 149.55 177.8 149.3 178.45 148.8 178.45 148.1 178.2 147.4 177.2 146.55 175.9 146.4 174.2 146.35 173.7 146.85 170.95 L146.9 170.3 Q146.8 169.15 145.55 168.05 L143.2 166.45 140.9 164.95 Q141.1 164.25 143.8 163.95 L148.55 163.7"
        />
        <path
          fill="#f5e7e6"
          d="M190.1 36.4 Q191.6 36.4 192.75 39.5 193.85 42.4 193.45 44.4 193.15 45.9 191.45 46.2 L188.8 46.0 Q187.65 45.4 187.1 44.1 186.05 41.7 187.4 38.95 188.6 36.4 190.1 36.4"
        />
        <path
          fill="#0d131a"
          d="M103.05 160.85 Q101.5 160.25 101.7 159.55 L103.85 159.5 Q111.3 162.15 125.95 162.95 142.1 163.85 154.4 161.55 L157.5 161.7 Q157.05 162.5 155.0 163.0 145.35 165.5 131.15 165.4 114.05 165.35 103.05 160.85"
        />
      </g>
    </svg>
  );
};

export default Gloom;
